export default __webpack_public_path__ + "static/io_io_logo-2cfa3f97382f28a5271336c4a2df770f.svg";